import React from 'react';

import { CardActionArea, CardContent, createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import Card, { CardProps } from '@material-ui/core/Card';

import { Typography, TypographyProps } from './Typography';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    cardContent: {
      height: 128,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: unit * 5,
    },
    iconWrapper: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
  });

export interface CardMessagingActivityProps extends Omit<CardProps, 'classes'>, WithStyles<typeof styles> {
  title: string;
  count: TypographyProps['children'];
  icon: React.ReactElement;
}

const CardMessagingActivity: React.FC<CardMessagingActivityProps> = ({ classes, title, count, icon, ...rest }) => (
  <Card className={classes.root} square {...rest}>
    <CardActionArea>
      <CardContent className={classes.cardContent}>
        <Typography variant="h4LargeStrongBold" mask="number" smallGutterBottom>
          {count}
        </Typography>
        <Typography variant="body1Large" color="textSecondary">
          {title}
        </Typography>
      </CardContent>
    </CardActionArea>
    <div className={classes.iconWrapper}>{icon}</div>
  </Card>
);

export default withStyles(styles)(CardMessagingActivity);
